/**
 * VendorLayout — the Gateway (vendor) section. Minimal: a few pages + overlays.
 * Uses the shared AppShell with a Gateway-specific nav config and a simplified
 * account menu (DEV-405).
 */
import { Outlet, useNavigate } from 'react-router-dom'
import { Building2, FileText, User as UserIcon } from 'lucide-react'
import AppShell, { type NavItem } from '../components/ui/AppShell'
import UserMenu from '../components/ui/UserMenu'
import { useUser } from '../contexts/UserContext'

// Level-2 nav config for the Gateway (vendor) section.
const GATEWAY_NAV: NavItem[] = [
  { label: 'Profile', to: '/submit', icon: Building2, end: true },
  { label: 'Submissions', to: '/submit/submissions', icon: FileText },
]

const VendorLayout = () => {
  const navigate = useNavigate()
  const { user } = useUser()

  const handleLogout = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    navigate('/')
  }

  return (
    <AppShell
      nav={GATEWAY_NAV}
      homeTo="/submit"
      footer={(collapsed) => (
        <UserMenu
          collapsed={collapsed}
          onLogout={handleLogout}
          userName={user?.full_name || user?.username || 'User'}
          userOfficeName={user?.organization || 'Vendor'}
          items={[
            { label: 'User Settings', icon: UserIcon, onClick: () => navigate('/submit/settings') },
          ]}
        />
      )}
    >
      <Outlet />
    </AppShell>
  )
}

export default VendorLayout
